import React from "react";

export const HEXArrowRight = () => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="c-hex-arrow-right"
    >
      <path
        d="M5.528 6.69466L5.05733 7.16666L6 8.10932L6.472 7.63866L5.528 6.69466ZM8.66667 4.49999L9.13867 4.97199L9.60933 4.49999L9.13867 4.02799L8.66667 4.49999ZM6.472 1.36132L6 0.890656L5.05733 1.83332L5.528 2.30532L6.472 1.36132ZM6.472 7.63866L9.13867 4.97199L8.19467 4.02799L5.528 6.69466L6.472 7.63866ZM9.13867 4.02799L6.472 1.36132L5.528 2.30532L8.19467 4.97199L9.13867 4.02799ZM8.66667 3.83332H0V5.16666H8.66667V3.83332Z"
        fill="#11387F"
      />
    </svg>
  );
};
